import { Reveal } from "../components/Reveal";
import { ContactCTA } from "../components/ContactCTA";
import { SERVICES, whatsappLink } from "../lib/data";
import { WhatsappLogo } from "@phosphor-icons/react";

export default function Servizi() {
  return (
    <div data-testid="servizi-page">
      <section className="max-w-[1400px] mx-auto px-6 lg:px-10 pt-44 pb-20">
        <Reveal>
          <div className="overline text-secondary mb-6">I nostri servizi</div>
          <h1 className="serif text-5xl md:text-7xl lg:text-8xl font-light tracking-tighter text-primary leading-[0.92] max-w-4xl">
            Cura totale della tua casa vacanza.
          </h1>
        </Reveal>
        <Reveal delay={0.15}>
          <p className="mt-8 text-lg font-light text-muted-foreground max-w-xl leading-relaxed">
            Cinque servizi pensati per gli host che vogliono offrire un'esperienza impeccabile senza occuparsi della gestione operativa.
          </p>
        </Reveal>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 lg:px-10 pb-20">
        {SERVICES.map((s, i) => {
          const reverse = i % 2 === 1;
          return (
            <Reveal key={s.id} delay={0.05}>
              <div data-testid={`servizio-${s.id}`}
                   className="grid md:grid-cols-2 gap-10 lg:gap-16 items-center py-16 border-t border-border/60">
                <div className={`overflow-hidden ${reverse ? "md:order-2 clip-br" : "clip-tl"}`}>
                  <img src={s.img} alt={s.title}
                       className="w-full h-[340px] md:h-[440px] object-cover hover:scale-105 transition-transform duration-700" />
                </div>
                <div className={reverse ? "md:order-1" : ""}>
                  <span className="serif text-6xl font-light text-secondary">{s.num}</span>
                  <h2 className="serif text-4xl md:text-5xl font-light tracking-tight text-primary mt-4 mb-5">{s.title}</h2>
                  <p className="font-light text-muted-foreground text-lg leading-relaxed max-w-md">{s.desc}</p>
                  <a href={whatsappLink(`Ciao Cleansof, vorrei informazioni sul servizio: ${s.title}.`)}
                     target="_blank" rel="noreferrer" data-testid={`servizio-cta-${s.id}`}
                     className="mt-8 inline-flex items-center gap-2 rounded-full border border-primary/25 text-primary px-7 py-3.5 hover:bg-primary hover:text-primary-foreground transition-colors">
                    <WhatsappLogo size={18} weight="fill" /> Richiedi questo servizio
                  </a>
                </div>
              </div>
            </Reveal>
          );
        })}
      </section>

      <ContactCTA />
    </div>
  );
}
